export default "skymp5-front/e95ee799589b5efe9680d8c2cbeace42.gif";